import React from 'react'
import Image from "next/image";
import styles from "./about-tnpsc.module.css";
import Banner from "../../assets/images/Tnpsc/tnpscbanner/TNPSC-Gr-I-II-Prelims-Coaching-Web-banner.webp";
import Banner1 from "../../assets/images/Tnpsc/tnpscbanner/TNPSC-Gr-II-&-IV--Web-banner--with-button (1).webp";
import Banner2 from "../../assets/images/Tnpsc/tnpscbanner/TNPSC-location-Banner-Web-banner-2-1.jpg";
import mbBanner from "../../assets/images/Tnpsc/tnpscbanner/TNPSC-Gr-I-II-Prelims-Coaching-Mobile-banner.webp";
import mbBanner1 from "../../assets/images/Tnpsc/tnpscbanner/TNPSC-Gr-II-&-IV-mob-banner-with-button (1).webp";
import mbBanner2 from "../../assets/images/Tnpsc/tnpscbanner/TNPSC--location-Banner---Mobile-banner (1).webp";
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import Interest from '../../components/might-be-interest';
import Pattern from '../tnpsc/pre-pattern';
import dynamic from 'next/dynamic';
import Carousel from 'react-bootstrap/Carousel';

const Syllabus = dynamic(()=>import( '../tnpsc/pre-syllabus'));
const Exam = dynamic(()=>import( "../tnpsc/pre-exam"));
const TNPSC_form = dynamic(()=>import( "../../components/Forms/about-tnpsc-forms"));
const TNPSC_test = dynamic(()=>import( "../about-tnpsc/test-series"));
import TNPSC_course from "../about-tnpsc/course-detials";
import TNPSC_prelims from "../about-tnpsc/prelims";
import Link from "next/link";
const About_TNPSC = () => {

  const banners = [
    { img: Banner, alt: "carousel", link:"#" },
    { img: Banner1, alt: "carousel", link: "/" },
    { img: Banner2, alt: "carousel", link: "/about-tnpsc" },
  ]

  const mbbanners = [
    { img: mbBanner, alt: "carousel", link:"#" },
    { img: mbBanner1, alt: "carousel", link: "/" },
    { img: mbBanner2, alt: "carousel", link: "/about-tnpsc" },
  ]

  return (
    <>
      <Navbar title="tnpsc" />

      <div className="container">
        <div className="pt-3 pt-md-5">
          <h1 className={`${styles.pagemaintitle}`}>TNPSC Group I & II Preliminary</h1>
        </div>
      </div>
      {/* large screens */}
      <div className="container">
        <div className="row">
          <div className="col px-0 d-none d-md-block">
            <Carousel>
              {banners.map((e, index) =>
                <Carousel.Item key={index}>
                  <Link href={e.link} rel="noreferrer">
                    <Image
                      className="carouselimage w-100 h-100"
                      src={e.img}
                      alt={e.alt}
                      title="Shankar IAS Academy"
                      loading="eager"
                      placeholder="blur"
                    /></Link>
                </Carousel.Item>
              )}
            </Carousel>
          </div>
        </div>
      </div>
      {/* small screens */}
      <div className="container">
      <div className="row">
          <div className="col px-0 d-block d-md-none">
            <Carousel>
              {mbbanners.map((e, index) =>
                <Carousel.Item key={index}>
                  <Link href={e.link} rel="noreferrer">
                    <Image
                      className="carouselimage"
                      src={e.img}
                      alt={e.alt}
                      title="Shankar IAS Academy"
                      placeholder="blur"
                    /></Link>
                </Carousel.Item>
              )}
            </Carousel>
          </div>
        </div>
      </div>

      <div className="container pt-3">
        <div className="row">
          <div className="col">
            <div
              className={`${styles.tabscrollclass} nav nav-pills mb-3 align-items-baseline`}
            >
              <Link href='/about-tnpsc'>
                <button
                  id={styles.tablinks}
                  className="nav-link py-2 px-0 me-4 active"
                  data-bs-toggle="pill"
                  data-bs-target="#centre-1"
                  type="button"
                  role="tab"
                  aria-controls="centre-1"
                  aria-selected="true"
                >
                  Anna Nagar
                </button>
              </Link>

              <Link href='/tnpsc-adyar'>
                <button
                  id={styles.tablinks}
                  className="nav-link py-2 px-0 me-4"
                  data-bs-toggle="pill"
                  data-bs-target="#centre-2"
                  type="button"
                  role="tab"
                  aria-controls="centre-2"
                  aria-selected="false"
                >
                  Adyar
                </button>
              </Link>

              <Link href='/tnpsc-trichy'>
                <button
                  id={styles.tablinks}
                  className="nav-link py-2 px-0 me-4"
                  data-bs-toggle="pill"
                  data-bs-target="#centre-3"
                  type="button"
                  role="tab"
                  aria-controls="centre-3"
                  aria-selected="false"
                >
                  Trichy
                </button>
              </Link>

              <Link href='/tnpsc-salem'>
                <button
                  id={styles.tablinks}
                  className="nav-link py-2 px-0 me-4"
                  data-bs-toggle="pill"
                  data-bs-target="#centre-4"
                  type="button"
                  role="tab"
                  aria-controls="centre-4"
                  aria-selected="false"
                >
                  Salem
                </button>
              </Link>

              <Link href='/tnpsc-coimbatore'>
                <button
                  id={styles.tablinks}
                  className="nav-link py-2 px-0 me-4"
                  data-bs-toggle="pill"
                  data-bs-target="#centre-5"
                  type="button"
                  role="tab"
                  aria-controls="centre-5"
                  aria-selected="false"
                >
                  Coimbatore
                </button>
              </Link>

              <Link href='/tnpsc-madurai'>
                <button
                  id={styles.tablinks}
                  className="nav-link py-2 px-0 me-4"
                  data-bs-toggle="pill"
                  data-bs-target="#centre-6"
                  type="button"
                  role="tab"
                  aria-controls="centre-6"
                  aria-selected="false"
                >
                  Madurai
                </button>
              </Link>

              <Link href='/tnpsc-namakkal'>
                <button
                  id={styles.tablinks}
                  className="nav-link py-2 px-0 me-4"
                  data-bs-toggle="pill"
                  data-bs-target="#centre-7"
                  type="button"
                  role="tab"
                  aria-controls="centre-7"
                  aria-selected="false"
                >
                  Namakkal
                </button>
              </Link>

              <Link href='/tnpsc-thiruvarur'>
                <button
                  id={styles.tablinks}
                  className="nav-link py-2 px-0 me-4"
                  data-bs-toggle="pill"
                  data-bs-target="#centre-8"
                  type="button"
                  role="tab"
                  aria-controls="centre-8"
                  aria-selected="false"
                >
                  Thiruvarur
                </button>
              </Link>

            </div>
          </div>
        </div>
      </div>

      <TNPSC_form />
      <TNPSC_course />
      <TNPSC_test />
      <TNPSC_prelims />

      <div className='container'>
        <div className='row pt-3'>
          <div className='col'>
            <Pattern />
          </div>
        </div>
      </div>
      <div className='container'>
        <div className='row pt-4'>
          <div className='col'>
            <Syllabus />
          </div>
        </div>
      </div>
      <div className='container-fluid' style={{ backgroundColor: "#F4F6F8" }}>
        <div className='row pt-4'>
          <div className='col'>
            <Exam />
          </div>
        </div>

      </div>

      <Interest />
      <Footer />
    </>
  )
}

export default About_TNPSC;